<template>
    <b-modal
        id="rubric-survey-show-add-students"
        v-model="modal"
        :title="$t('rubrics.add_students')"
        @ok="onOk"
        ok-only
        :ok-title="$t('common.close')"
        modal-class="apprentice-default-modal"
        size="xl">
        <b-tabs
            class="rubric-survey-students-tab apprentice-tab"
            content-class="rubric-survey-students-tab-content">
            <b-tab
                :title="$t('rubrics.all_students')"
                active>
                <design-2021-apprentice-data-table
                    :items="allUnselectedUsers"
                    :fields="fields">
                    <template v-slot:cell(action)="data">
                        <div class="group-actions">
                            <b-button
                                class="btn-add btn-open-group"
                                variant="primary-icon-only"
                                @click="addStudent(data.item.id)">
                            </b-button>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
            </b-tab>

            <b-tab
                v-if="unselectedUsers.length"
                :title="$t('rubrics.students_linked_to_invitation')">
                <design-2021-apprentice-data-table
                    :items="unselectedUsers"
                    :fields="fields">
                    <template v-slot:cell(action)="data">
                        <div class="group-actions">
                            <b-button
                                class="btn-add btn-open-group"
                                variant="primary-icon-only"
                                @click="addStudent(data.item.id)">
                            </b-button>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
            </b-tab>
        </b-tabs>
    </b-modal>
</template>

<script>
import { ords } from '../../../../../app';

export default {
    name: 'design-2021-rubric-survey-add-students-modal-component',
    props: ['rubricSurveyIn'],
    data() {
        return {
            modal: false,
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('rubrics.student'),
                    sortable: true,
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            unselectedUsers: [],
            allUnselectedUsers: [],
        };
    },
    methods: {
        addStudent(userId) {
            let data = {
                user_id: userId,
            };

            this.alert.saving();
            this.axios.post(this.routes.rubricSurveyStudentsAdd(this.rubricSurveyIn.id), data).then(
                (response) => {
                    this.rubricSurveyIn.addRelation('rubric_survey_users', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onOk() {
            this.modal = false;
        },

        show(rubric_survey_id) {
            this.unselectedUsers = [];
            this.allUnselectedUsers = [];

            this.axios.get(this.routes.rubricSurveyStudents(rubric_survey_id)).then(
                (response) => {
                    ords.hold();
                    this.rubricSurveyIn.addRelation('las_groups', response.data.selected_las_groups);
                    this.rubricSurveyIn.addRelation('las_main_groups', response.data.selected_las_main_groups);
                    this.rubricSurveyIn.addRelation('groups', response.data.selected_projects);
                    //
                    // // temp fix;
                    // for (const lasGroup of response.data.selected_las_groups) {
                    //     for (const lasGroupLasStudent of lasGroup.students) {
                    //
                    //     }
                    // }

                    ords.continue();

                    ords.use('user').add(response.data.all_students);

                    ords.use('user')
                        .where((whereCallback) => {
                            whereCallback.where((lasStudentWhereCallback) => {
                                lasStudentWhereCallback.whereHas('las_student', (lasStudentCallback) => {
                                    lasStudentCallback.where((lasGroupWhereCallback) => {
                                        lasGroupWhereCallback.whereHas('las_groups', (lasGroupCallback) => {
                                            lasGroupCallback.whereHas('rubric_surveys', (rubricSurveyCallback) => {
                                                rubricSurveyCallback.where('id', '=', this.rubricSurveyIn.id);
                                            });
                                        });
                                    });
                                    lasStudentCallback.orWhere((lasMainGroupWhereCallback) => {
                                        lasMainGroupWhereCallback.whereHas(
                                            'las_main_groups',
                                            (lasMainGroupCallback) => {
                                                lasMainGroupCallback.whereHas(
                                                    'rubric_surveys',
                                                    (rubricSurveyCallback) => {
                                                        rubricSurveyCallback.where('id', '=', this.rubricSurveyIn.id);
                                                    },
                                                );
                                            },
                                        );
                                    });
                                });
                            });
                            whereCallback.orWhere((groupWhereCallback) => {
                                groupWhereCallback.whereHas('projects', (projectCallback) => {
                                    projectCallback.whereHas('group', (groupCallback) => {
                                        groupCallback.whereHas('rubric_surveys', (rubricSurveyCallback) => {
                                            rubricSurveyCallback.where('id', '=', this.rubricSurveyIn.id);
                                        });
                                    });
                                });
                            });
                        })
                        .where('type', '=', 'student')
                        .whereDoesntHave('rubric_survey_user')
                        .get()
                        .subscribe((users) => {
                            this.unselectedUsers = users;
                        });

                    ords.use('user')
                        .where('type', '=', 'student')
                        .whereDoesntHave('rubric_survey_user')
                        .get()
                        .subscribe((users) => {
                            this.allUnselectedUsers = users;
                        });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );

            this.modal = true;
        },
    },
};
</script>

<style scoped lang="scss">
.group-actions {
    display: flex;
    margin-right: map-get($grid-gutter-spacing, 'twenty-one');

    .btn {
        font-size: 1.3125rem;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}
</style>
